import _ from 'lodash';

export const useNewStyleGuide = (state, withStyleguide = false) =>
  _.get(state, 'internalStore.styleGuide', false) || withStyleguide;

export default { useNewStyleGuide };
